export default {
  /* Events */
  restaurant: 'Restaurant',
  bar: 'Bar',
  hotel: 'Hotel',
  museum: 'Museum',
  cultureHouse: 'Culture House',
  park: 'Park',
  gym: 'Gym',
  comercialCenter: 'Shopping Mall',
  theatre: 'Theatre',
  cafe: 'Cafe',
  library: 'Library',
  house: 'House',
  assistantsExportedSuccessfully: 'Assistants exported successfully',
  createEvent: 'Create event',
  mustChargeBeforeCreateEvents: 'You must charge money before creating events',
  events: 'Events',
  published: 'Published',
  notPublished: 'Not published',
  soldOut: 'Sold out',
  publishEventToBeShownInSalesLists: 'Publish this event to be shown in sales lists',
  loadingEvents: 'Loading events',
  noEventsRegistered: 'No events registered',
  publish: 'Publish',
  soldTickets: 'Sold tickets',
  availableTickets: 'Available tickets',
  totalTickets: 'Tickets amount',
  eventStateUpdated: 'Event state updated',
  profileImage: 'Profile image',
  thePicture: 'The picture',
  thePictures: 'The pictures',
  theMiniatures: 'The miniatures',
  theBanner: 'The banner',
  eventRating: 'Event rating',
  priceRating: 'Price rating',
  profitability: 'Profitability',
  businessFee: 'Business fee',
  gatewayFee: 'Gateway fee',
  totalProfit: 'Net profit',
  tags: 'Tags',
  createTag: 'Create tag',
  purchase: 'Purchase',
  /* End Events */
  /* Promotors */
  createPromotor: 'Create promotor',
  mustChargeBeforeCreatingPromotors: 'You must charge money before creating promotors',
  promotors: 'Promotors',
  showUrlToPromotor: 'Show url to promotor',
  editPromotor: 'Edit promotor',
  setProfilePicture: 'Set profile picture',
  setBanner: 'Set banner',
  deletePromotor: 'Delete promotor',
  loadingPromotor: 'Loading promotors',
  noPromotorsRegistered: 'There aren\'t promotors registered',
  /* End Promotors */
  /* Djs */
  view: 'View',
  djSuccessfullyCreated: 'Dj successfully created',
  djSuccessfullyUpdated: 'Dj successfully updated',
  createDj: 'Create dj',
  mustChargeBeforeCreatingDjs: 'You must recharge money before creating djs',
  djs: 'Djs',
  followers: 'Followers',
  showUrlToDj: 'Show url to dj',
  editDj: 'Edit dj',
  deleteDj: 'Delete dj',
  loadingDj: 'Loading djs',
  noDjsRegistered: 'There aren\'t djs registered',
  doYouWantToDeleteDj: 'Do you want to delete the Dj?',
  seeDjInYourWebSite: 'See dj in your website',
  mustDoToSeeDjInWebSite: 'In order to see the dj, you must be sure to have the events widget attached in your website, to enter the next url',
  mustContactSupportToSeeDjInWebSite: 'In order to see the dj, you must contact support to get an url',
  /* End Djs */
  /* Products Categories */
  createProductsCategory: 'Create products category',
  mustChargeBeforeCreatingProductsCategories: 'You must charge money before creating products categories',
  successfullyCreatedProductCategory: 'Product created successfully',
  successfullyUpdatedProductCategory: 'Product updated successfully',
  productsCategories: 'Products Categories',
  newProductsCategory: 'New products category',
  editProductsCategory: 'Edit products category',
  photos: 'Photos',
  setProductsCategoryPhoto: 'Set products category Photo',
  miniaturePhotos: 'Miniature Photos',
  setProductsCategoryMiniaturePhoto: 'Set products category miniature photo',
  deleteProductsCategory: 'Delete products category',
  loadingProductsCategory: 'Loading products categories',
  noProductsCategoriesRegistered: 'There aren\'t products categories registered',
  doYouWantToDeleteProductsCategory: 'Do you want to delete the products category?',
  /* End Products Categories */
  /* Products */
  price: 'Price',
  discountPrice: 'Discount price',
  stock: 'Stock',
  createProduct: 'Create product',
  mustChargeBeforeCreatingProducts: 'You must charge money before creating products',
  products: 'Products',
  newProduct: 'New Product',
  editProduct: 'Edit product',
  // // photos: 'Photos',
  setProductPhoto: 'Set Product Photo',
  // // miniaturePhotos: 'Miniature Photos',
  setProductMiniaturePhoto: 'Set Product Miniature Photo',
  deleteProduct: 'Delete product',
  loadingProduct: 'Loading products',
  noProductsRegistered: 'There aren\'t products registered',
  doYouWantToDeleteProduct: 'Do you want to delete the product?',
  /* End Products */
  /* Purchase Products */
  purchaseId: 'Purchase Id',
  purchasePaymentMethod: 'Payments Method',
  shippingAddress: 'Shipping Address',
  payAmount: 'Pay Amount',
  paymentDate: 'Payment Date',
  createProductPurchase: 'Create product purchase',
  mustChargeBeforeCreatingProductPurchases: 'You must charge money before creating product purchases',
  productPurchases: 'Product Purchases',
  newProductPurchase: 'New Product Purchase',
  viewProductPurchase: 'View Product Purchase',
  editProductPurchase: 'Edit product purchase',
  deleteProductPurchase: 'Delete product purchase',
  loadingProductPurchase: 'Loading product purchases',
  noProductPurchasesRegistered: 'There aren\'t product purchases registered',
  doYouWantToDeleteProductPurchase: 'Do you want to delete the product purchase?',
  /* End Purchase Products */
  provider: 'Provider',
  providers: 'Providers',
  createProvider: 'Create provider',
  mustChargeBeforeCreatingProviders: 'You must charge money before creating providers',
  newProvider: 'New Provider',
  editProvider: 'Edit provider',
  deleteProvider: 'Delete provider',
  loadingProvider: 'Loading providers',
  noProvidersRegistered: 'There aren\'t providers registered',
  doYouWantToDeleteProvider: 'Do you want to delete the provider?',
  providerHasBeenDeleted: 'The provider has been deleted successfully',
  fabric: 'Fabric',
  fibre: 'Fibre',
  key: 'key',
  positionArc: 'Position Arc',
  acab: 'Acab',
  acabado: 'Acabado',
  refChina: 'Reference China',
  refClient: 'Reference Client',
  label: 'Label',
  wide: 'Wide',
  weight: 'Weight',
  composition: 'Composition',
  perfomance: 'Perfomance',
  unitMeasure: 'Unit Measure',
  cantMtsFinals: 'cant Mts Finals',
  cantKlsFinals: 'cant Kls Finals',
  cantMtKl: 'cant Mt Kl',
  capMaxKl: 'cap Max Kl',
  portOcupation: 'port Ocupation',
  // newProduct: 'New Product',
  // editProduct: 'Edit product',
  // deleteProduct: 'Delete product',
  // loadingProduct: 'Loading products',
  // noProductsRegistered: 'There aren\'t products registered',
  // doYouWantToDeleteProduct: 'Do you want to delete the product?',
  productHasBeenDeleted: 'The product has been deleted successfully',
  /* End Products */
  /** *** End Orders */
  attachEventsInYourWebSite: 'Insert events in your web site',
  createDivElementToAttachEventsInYourWebSite: 'In order to attach events to your web site, you must create a div element with the id',
  andOtherWithTheId: 'and other with the id',
  inYourSiteBody: 'In your web site\'s body tag',
  andThenAddTheNextScriptInTheFooter: 'And then add the next script to your site\'s footer',
  scriptCopied: 'Script copied',
  errorCopyingTheScript: 'Error copying the script',
  exportAssistants: 'Export assistants',
  assistantsList: 'Assistants list',
  assistantId: 'Assistant\'s id',
  loadingAssistants: 'Loading assistants',
  noAssistantsRegistered: 'There aren\'t registered assistants',
  registerDate: 'Register date',
  automatic: 'Automatic',
  manual: 'Manual',
  creationType: 'Creation type',
  errorLoadingEvent: 'There was an error loading the event',
  eventNotPublishedAndOutOfLists: 'Your event hasn\'t been published, and it is not going to be seen in the lists until it is',
  eventDate: 'Event date',
  publishEvent: 'Publish event',
  seePromotorInYourWebSite: 'See promotor in your web site',
  mustDoToSeePromotorInWebSite: 'In order to see the promotor, you must be sure to have the events widget attached in your website, to enter the next url',
  copy: 'Copy',
  mustContactSupportToSeePromotorInWebSite: 'In order to see the promotor, you must contact support to get an url',
  errorCopyingUrl: 'Error copying the url',
  urlCopied: 'Url copied',
  eventContacts: 'Event contacts',
  doYouWantToDeletePromotor: 'Do you want to delete the promotor?',
  importAssistants: 'Import assistants',
  event: 'Event',
  assistantsImportedSuccessfully: 'Assistants imported successfully',
  format: 'Format',
  editEvent: 'Edit event',
  newEvent: 'New event',
  shortDescription: 'Short description',
  note: 'Note',
  insertNoteToSendInConfirmationEmail: 'Insert a note to send in the confirmation email',
  isAnOnlineEvent: 'It is an online event',
  eventUrl: 'Event\'s url',
  category: 'Category',
  startDate: 'Start date',
  finishDate: 'Finish date',
  startDateAccess: 'Access start date',
  finishDateAccess: 'Access finish date',

  /* Places */
  place: 'Place',
  places: 'Places',
  preferences: 'Preferences',
  placeLocation: 'Place location',
  cantFindPlace: 'Can\'t find a place? Register one.',
  canFindPlace: 'Have a place in mind? Select one.',
  mustChargeBeforeCreatingPlaces: 'You must charge money before creating a place',
  newPlace: 'Create place',
  editPlace: 'Edit place',
  viewPlace: 'See place',
  setPlacePhoto: 'Upload place photo',
  deletePlace: 'Delete place',
  loadingPlace: 'Loading places',
  noPlacesRegistered: 'No registered places',
  doYouWantToDeletePlace: '¿Do you want to delete this place?',
  infoPlace: 'Place information',
  placeSocialNetworks: 'Place social networks',
  placeContacts: 'Place contacts',
  ExpAndOffs: 'Experiences and offerings',
  experiences: 'Experiences',
  trips: 'Trips',
  concerts: 'Concerts',
  offerings: 'Offerings',
  veggie: 'Vegetarian',
  allergies: 'Allergies',

  latitude: 'Latitude',
  longitude: 'Longitude',
  organizer: 'Organizer',
  limitRegisterByIdentificationDocument: 'Limit register by identification document',
  cover: 'Cover',
  pictures: 'Photos | Photo',
  eventCreated: 'Event created',
  categorieCreated: 'Categorie created',
  preferenceCreated: 'Preference created',
  promoter: 'Promotor',
  locationUrl: 'Url to location',
  facebookMessageSendingUrl: 'Facebook message sending Url',
  facebookSiteUrl: 'Facebook Site Url',
  completeRequiredFields: 'Complete the required fields',
  promoterSuccessfullyCreated: 'Promotor was successfully created',
  promoterSuccessfullyUpdated: 'Promotor was successfully updated',
  eventSocialNetworks: 'Event social networks',
  socialNetworkSelect: 'Select the social network',
  doYouWantDuplicate: 'Do you want to duplicate this place?',
  isPlaceActive: 'Is this place active?',
  isThisPlaceRestaurant: 'This place is a restaurant',
  configPlace: 'Place configuration',
  placeTags: 'Tags of your place',
  placeRating: 'Place ranking',
  tagsHint: 'Write a tag, then press Enter',
  pleaseTypeLocation: 'Please type your address',
  diningStyle: 'Dining style',
  dressCode: 'Dress code',
  acceptedPaymentMethods: 'Accepted payment methods',
  parkingType: 'Parking type',
  casual: 'Casual',
  businessCasual: 'Business casual',
  casualElegant: 'Casual elegant',
  formal: 'Formal',
  jacketRequired: 'Jacket required',
  jacketAndTie: 'Jacket and tie',
  priceAverage: 'Price average',
  brunch: 'Brunch',
  lunch: 'Lunch',
  happyHour: 'Happy hour',
  dinner: 'Dinner',
  daily: 'Daily',

  eventTypeCamping: 'Camping, traveling or retreat',
  eventTypeAttraction: 'Attraction',
  eventTypeRace: 'Endurance race or event',
  eventTypeDinner: 'Dinner or gala',
  eventTypeWorkshop: 'Class, course or workshop',
  eventTypeSignature: 'Appearance or signature',
  eventTypeConcert: 'Concert or performance',
  eventTypeConference: 'Conference',
  eventTypeConvention: 'Convention',
  eventTypeMeetup: 'Network event or meeting',
  eventTypeFair: 'Trade fair, consumer fair or exhibition',
  eventTypeFestival: 'Festival or fair',
  eventTypeParty: 'Party or social gathering',
  eventTypeCompetition: 'Game or competition',
  eventTypeOther: 'Other',
  eventTypeProjection: 'Projection',
  eventTypeRally: 'Rally',
  eventTypeSeminar: 'Seminar or talk',
  eventTypeTournament: 'Tournament',
  eventTypeVisit: 'Visit',

  eventCategoryAcademic: 'School activities',
  eventCategoryHobbies: 'Hobbies and special interests',
  eventCategoryArts: 'Performing and visual arts',
  eventCategoryScience: 'Science and Technology',
  eventCategoryCinema: 'Cinema, media and entertainment',
  eventCategoryCars: 'Cars, ships and planes',
  eventCategoryCommunities: 'Community and culture',
  eventCategorySports: 'Sports and health',
  eventCategoryHolidays: 'Holidays',
  eventCategoryFamily: 'Family and education',
  eventCategoryGastronomy: 'Gastronomy',
  eventCategoryPolitics: 'Government and politics',
  eventCategoryHousing: 'Home and lifestyle',
  eventCategoryFashion: 'Fashion and beauty',
  eventCategoryMusic: 'Music',
  eventCategoryBusiness: 'Business and professional services',
  eventCategorySocial: 'Charitable organizations and causes',
  eventCategoryOther: 'Other',
  eventCategoryReligion: 'Religion and spirituality',
  eventCategoryHealth: 'Health & Wellness',
  eventCategoryOutdoors: 'Travel and outdoor activities',
  /* End Places */

  urlOrLink: 'URL or link',
  socialNetworkAdd: 'Add social network',
  eventCurrency: 'Event currency',
  ticketTitle: 'Ticket title',
  ticketPrice: 'Ticket price',
  ticketingServicePrice: 'Ticketing service price',
  startOfSale: 'Start of Sale',
  endOfSale: 'End of Sale',
  ticketsNumber: 'Number of tickets',
  maxTicketsPerPerson: 'Maximum number of tickets per person',
  deleteTicket: 'Delete ticket',
  addTicket: 'Add Ticket',
  result: 'Result',
  ofPromoter: 'of the promotor',
  upload: 'Upload',
  allowedFormats: 'Only these formats are allowed',
  maxPictureSize: 'Picture must have a maximum size of',
  and: 'and',
  dragAndDropFile: 'Drag and drop the file here',
  imageSuccessfullyLoaded: 'Image successfully loaded',
  deleteSelection: 'Delete Selection',
  analyze: 'Analyze',
  atLeastOneFileToContinue: 'Enter at least one file to continue',
  nextStep: 'Next step',
  theFile: 'The file',
  notAccepted: 'was not accepted',
  seeEvent: 'See event',
  registerAttender: 'Register Assistant',
  advancedSearch: 'Advanced Search',
  assistantsPerPage: 'Assistants per Page',
  assistantName: 'Assistant name',
  creation: 'Creation',
  ticket: 'Ticket',
  register: 'Register',
  assistantRegistered: 'Assistant registered',
  buyer: 'Buyer',
  cost: 'Cost',
  parallelAnswer: 'Parallel Answer',
  franchise: 'Franchise',
  bank: 'Bank',
  ofPurchase: 'of purchase',
  download: 'Download',
  dataCopied: 'Data Copied',
  errorTryAgain: 'An error occurred, try again',
  checkInState: 'Check-in state',
  check: 'Check',
  checkedIn: 'Checked-in',
  unCheck: 'Uncheck',
  zipCode: 'Zip Code',
  currency: 'Currency'
}
